<template>
  <ul class="tab-bar clearfix">
    <li
      v-for="(nav, index) in navList"
      :key="index"
      :class="{
        pre: nav.targetRouterName === currentItem.targetRouterName,
      }"
    >
      <nav-link-item :nav="nav" />
    </li>
  </ul>
</template>

<script>
import NavLinkItem from './components/NavLinkItem';

export default {
  components: { NavLinkItem },
  props: {
    navList: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentItem: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '' }),
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  mounted() {},
  created() {},
  methods: {
  },
};
</script>

<style lang="scss" scoped>
  .pai-content .tab-bar{
    display: flex;
    align-items: flex-end;
    width: 3.12rem;
    height: 0.5rem;
    margin-left: .24rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    margin-bottom: .1rem;
    li{
      height: 0.55rem;
      a{
        color: #fff;
      }
    }
  }

  .pai-content .tab-bar li.pre a::after {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 0.02rem;
    background: #fff;
    content: "";
  }

  .tab-bar li {
    margin: 0;
    width: 1.56rem;
    height: 0.62rem;
    line-height: 0.62rem;
    padding: 0;
    box-sizing: border-box;
  }

  .tab-bar /deep/ .nav-link-item {
    display: block;
    height: 100%;
    text-align: center;
    padding: 0;
    line-height: 0.62rem;
  }

  // .tab-bar li.pre {
  //   background: url(~@img/be_tit.png) no-repeat;
  //   background-size: cover;
  // }

  .tab-bar li.pre /deep/ .nav-link-item::after {
    background: #fff;
  }

  .tab-bar li.pre /deep/ .nav-link-item {
    padding: 0;
  }
</style>
